module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_03-6f0ca6240a8104509e3a2b8f3ddbcf2b.svg";